import {z} from "zod/v4-mini"
import {graphNode} from "@cm/graph-v3"
import {registerTemplateGraphNode} from "#template/template-node/register"
import {pointGeometryAttributeSetLikeMarker} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import {PointGeometryAttributeSetRecordInput} from "#template/nodes/geometry-graph/attribute-set/attribute-set-record-input/point-geometry-attribute-set-record-input"
import {PointGeometryAttributeSetPointLikeInput} from "#template/nodes/geometry-graph/attribute-set/point-geometry-attribute-set-point-like-input"
import type {PointGeometryAttributeSetRecordInputParameters} from "#template/nodes/geometry-graph/attribute-set/attribute-set-record-input/point-geometry-attribute-set-record-input"
import type {PointGeometryAttributeSetPointLikeInputParameters} from "#template/nodes/geometry-graph/attribute-set/point-geometry-attribute-set-point-like-input"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {IModifyTemplateGraph} from "#template/interactions"
import type {PointGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import type {AttributeSetParameters} from "#template/nodes/geometry-graph/attribute-set/attribute-set-builder/geometry-attribute-set-builder-node"
import {GeometryAttributeSetBuilderNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-builder/geometry-attribute-set-builder-node"

export type PointGeometryAttributeSetParameters = AttributeSetParameters<PointGeometryAttributeSetRecordInput | PointGeometryAttributeSetPointLikeInput>

export interface SetPointGeometryAttributeSetInput {
    setObjectLikeInput(parameters: PointGeometryAttributeSetPointLikeInputParameters | null, modifyTemplateGraph: IModifyTemplateGraph): void
    setRecordInput(parameters: PointGeometryAttributeSetRecordInputParameters | null, modifyTemplateGraph: IModifyTemplateGraph): void
}

const definition: TemplateNodeDefinition<PointGeometryAttributeSetParameters> = {
    nodeClass: "PointGeometryAttributeSet",
    validation: {
        parameters: z.object({
            name: z.string(),
            input: z.union([graphNode(PointGeometryAttributeSetRecordInput), graphNode(PointGeometryAttributeSetPointLikeInput)]),
        }),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class PointGeometryAttributeSet
    extends GeometryAttributeSetBuilderNode<0, PointGeometryAttributeSetRecordInput | PointGeometryAttributeSetPointLikeInput>
    implements PointGeometryAttributeSetLikeNode, SetPointGeometryAttributeSetInput
{
    get [pointGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
    setObjectLikeInput(parameters: PointGeometryAttributeSetPointLikeInputParameters | null, modifyTemplateGraph: IModifyTemplateGraph): void {
        modifyTemplateGraph.modifyTemplateGraph(() =>
            this.updateParameters({input: new PointGeometryAttributeSetPointLikeInput({parameters: parameters ? {...parameters} : {point: null}})}),
        )
    }

    setRecordInput(parameters: PointGeometryAttributeSetRecordInputParameters | null, modifyTemplateGraph: IModifyTemplateGraph): void {
        modifyTemplateGraph.modifyTemplateGraph(() =>
            this.updateParameters({input: new PointGeometryAttributeSetRecordInput({parameters: parameters ? {...parameters} : {record: {}}})}),
        )
    }
}
